export const getCiudadProvincia = aviso => {
  let [ciudad, provincia] = aviso?.localizacion ? aviso.localizacion.split(',') : []
  if (!provincia && ciudad) {
    provincia = ciudad
    ciudad = undefined
  }
  return { ciudad: ciudad?.trim(), provincia: provincia?.trim() }
}
